import { createSearchParams } from 'react-router-dom';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { replace } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const addQueryParamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.addParam),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { name, value } = payload;
    const location = locationSelector(state);

    const searchParams = createSearchParams(location.search);
    if (Array.isArray(value)) {
      searchParams.delete(name);
      value.forEach((val) => {
        searchParams.append(name, String(val));
      });
    } else {
      searchParams.set(name, String(value));
    }

    return [
      replace({
        ...location,
        search: searchParams.toString(),
      }),
    ];
  }),
);
